import React, { Component } from 'react';
import { Tabs, WhiteSpace, Button, Toast, Tag, Modal } from 'antd-mobile';
import { Link } from "react-router-dom";
import { CommonlyHeadMembers } from '../../common/headnav';
import { Refund } from '../order/refund';
import { AddIntegral } from "../integral/addintegral";
import * as services from '../../projects/services';
import * as fun from '../../../components/common';
import $ from "jquery";
import { createBrowserHistory } from "history";
import './style.less';
const history = createBrowserHistory();
const alert = Modal.alert;
let page = 1;
let rows = 5;
let total = 0;
let oid = 0;
let statusid = 0;
export default class OrdermentList extends Component {
    constructor(props) {
        super(props);
        const tabs = [
            { title: '待预约', sub: '1' },
            { title: '待体检', sub: '2' },
            { title: '已体检', sub: '3' },
            { title: '退款中', sub: '4' },
        ];
        page = 1;
        rows = 5;
        total = 0;
        oid = 0;
        statusid = 0;
        statusid = this.props.match.params.oid;
        oid = this.props.match.params.oid;
        if (parseInt(this.props.match.params.oid) === 0) {
            statusid = 0;
        } else if (parseInt(this.props.match.params.oid) === 1) {
            statusid = 5;
        }
        else if (parseInt(this.props.match.params.oid) === 2) {
            statusid = 2;
        }
        else if (parseInt(this.props.match.params.oid) === 3) {
            statusid = 1;
        }

        this.state = {
            tabs: tabs,
            oid: this.props.match.params.oid,
            OrdermentList: [],
            orderlist: [],
            unionList: [],
            statusid: statusid,
            page: page,
            rows: rows,
            modal1: false,
            modal3: false,
            detailid: 0,
        }
      
    }
    onChange = (key) => {

    }
    mrefund = (detailid, e) => {
        this.setState({
            modal3: true, detailid: detailid
        });
    }
    onload = () => {
        page = 1;
        this.setState({ page: 1, statusid: 0 });
        let params2 = { page: 1, rows: this.state.rows, status: 0 };
        this.GetCredentialsLists(params2);
    }
    onClose = key => () => {
        this.setState({
            [key]: false,
        });
    }
    onAdd = (e) => {
        this.setState({
            modal1: true
        });
    }  
    componentDidMount() {       
        let params = { page: 1, rows: 100 };
        services.GetUserCardList(params, '正在查询，请稍后').then((data) => {
            if (data.status === 0) {
                if (!!data.result) {
                    if (!!data.result.rows) {
                        let cardlist2 = (data.result.rows.filter(item => item.cardStatus === 0));
                        this.setState({ orderlist: cardlist2 });
                    }
                }
            } else {
                Toast.offline(data.message);
            }
        });
        let params2 = { page: this.state.page, rows: this.state.rows, status: this.state.statusid };
        this.GetCredentialsLists(params2);
        const loadMoreDataFn = this.loadMoreDataFn;
        let timeCount;
        function callback() {
            if (!!document.getElementById("refid" + oid)) {
                let top = document.getElementById("refid" + oid).getBoundingClientRect().top;
                const windowHeight = window.screen.height;
                if (top && top < windowHeight + 1 && total / rows >= page) {
                    page++;
                    loadMoreDataFn(page);
                }
            }
        }
        window.addEventListener('scroll', function () {
            if (this.state.isLoadingMore) {
                return;
            }
            if (timeCount) {
                clearTimeout(timeCount);
            }
            timeCount = setTimeout(callback, 50);
        }.bind(this), false);
    }
    //再次加载
    loadMoreDataFn = (page) => {
        this.setState({ page: page });
        let parameter = { page: page, rows: rows, status: statusid };
        services.GetCredentialsLists(parameter, '').then(data => {
            if (data.status === 0) {
                if (data.result.total > 0) {
                    total = data.result.total;
                    let unionList = this.state.unionList.concat(data.result.rows);
                    this.setState({ unionList: unionList });
                }
            } else {
                Toast.offline(data.message);
            }
        });
    }
    GetCredentialsLists = (params2) => {
        services.GetCredentialsLists(params2, '').then(data => {
            if (data.status === 0) {
                if (data.result.total > 0) {
                    total = data.result.total;
                    this.setState({ unionList: data.result.rows });
                }
            } else {
                Toast.offline(data.message);
            }
        });
    }
    CancelOrderment = (data) => {
        let params = { cId: data.credentialid, sId: data.scheduleId, pId: data.peopleId };

        services.CancelOrderment(params, '正在取消请稍后').then(item => {
            if (item.status === 0) {
                this.setState({ oid: 0, unionList: [], statusid: 0 });
                let params2 = { page: 1, rows: this.state.rows, status: 0 };
                this.GetCredentialsLists(params2);
            } else {
                Toast.offline(item.message);
            }
        })
    }
    colortype = (type) => {
        if (parseInt(type) === 0) {
            return 'b';

        } else if (parseInt(type) === 2) {
            return 'gy';
        } else {
            return 'r';
        }
    }
    onTabClick = (index) => {
        page = 1;
        oid = index;
        this.setState({ oid: index, unionList: [] });
        if (parseInt(index) === 0) {
            statusid = 0;
        } else if (parseInt(index) === 1) {
            statusid = 5;
        }
        else if (parseInt(index) === 2) {
            statusid = 2;
        }
        else if (parseInt(index) === 3) {
            statusid = 1;
        }
        $("html,body").animate({
            scrollTop: 0
        }, 0);

        this.setState({ page: 1, status: statusid });
        let params2 = { page: 1, rows: this.state.rows, status: statusid };
        this.GetCredentialsLists(params2);
    }
    GetOrderListpage = () => {

    }
    render() {
        const { tabs, orderlist, unionList } = this.state;
        return <div className="ordermentList"  >
            <CommonlyHeadMembers barname="我的预约" />
            <Tabs tabs={tabs}
                id="refid"
                initialPage={parseInt(this.props.match.params.oid)}
                page={parseInt(this.state.oid)}
                activeTab={parseInt(this.state.oid)}
                swipeable={false}
                onChange={(tab, index) => { }}
                onTabClick={(tab, index) => { this.onTabClick(index); }}
                usePaged={true}
            >

                <div id="refid0">
                    {
                        (!!orderlist === false || orderlist.length === 0) && (!!unionList === false || unionList.length === 0)
                            ? <div className="errordiv"><img alt='' src={require('../../../res/images/zwsj.png')} />
                                <p>暂时没有您要的数据</p>
                            </div> : ''
                    }
                    {
                        !!orderlist === false || orderlist.length === 0 ? '' :
                            orderlist.map((data, index) => (
                                <div key={index}>
                                    <WhiteSpace size="lg" />
                                    <div className="integralbox" >
                                        <div className="integral-title">
                                            健康积分编号：{data.cardCode}
                                        </div>
                                        <div className="integral-cen" >
                                            <div className="cen-box">
                                                <div className="cen-a"><span>{data.cardMoney}</span><span>积分</span><Tag className={this.colortype(data.cardStatus)} >{data.cardStatusName}</Tag></div>
                                                <div className="cen-c"><span>有效期：
                                                {fun.FormatTimestr(data.createTime, 'YYYY-MM-dd')}至{fun.FormatTimestr(data.cardExpiredDate, 'YYYY-MM-dd')}</span></div>
                                                {
                                                    !!data.isDestination === false ?
                                                        <div className="cen-c">使用范围：通用</div>
                                                        :
                                                        <div className="cen-c">使用范围：<Link to={`/members/integralSyfw/` + data.publicId}>指定体检中心</Link></div>
                                                }
                                            </div>
                                            <div className="cen-but">
                                                <Button className="cenbut" onClick={
                                                    () => {
                                                        localStorage.removeItem('orderment');
                                                        localStorage.removeItem('peopleInfo');
                                                        history.push(`/members/orderment/add/${data.publicId}/0/null`);
                                                        history.go();
                                                    }
                                                } >立即预约</Button>


                                            </div>
                                        </div>

                                    </div>
                                </div>
                            ))
                    }
                    {
                        !!unionList === false || unionList.length === 0 ?
                            ''
                            :
                            unionList.map((data, index) => (
                                <div key={index}>
                                    <WhiteSpace size="lg" />
                                    <div className="integralbox" >
                                        <div className="integral-title">
                                            体检验证码：{data.credentialno}
                                        </div>
                                        <div className="integral-cen" >
                                            <div className="cen-box">
                                                <div className="cen-c" ><span>套餐名称：<Link to={`/package/item/${data.opid}/${!!data.title ? data.title : '测试套餐'}/${data.price}`}>{data.title}</Link></span></div>
                                                <div className="cen-c">套餐金额：<span className="mprice">{data.price}<span>积分</span></span></div>
                                                <div className="cen-c"><span>有效期：{fun.FormatTimestr(data.createtime, 'YYYY-MM-dd')}至{fun.FormatTimestr(data.cardexpireddate, 'YYYY-MM-dd')}</span></div>
                                            </div>
                                            <div className="cen-but">
                                                <Button className="cenbut" onClick={
                                                    () => {
                                                        localStorage.removeItem('orderment');
                                                        localStorage.removeItem('peopleInfo');
                                                        localStorage.setItem('orderment_order', JSON.stringify(data));
                                                        history.push(`/members/orderment/add/0/${data.orderid}/${data.opid}`);
                                                        history.go();
                                                    }
                                                } >立即预约</Button>
                                                <Button className="cenbut" onClick={this.mrefund.bind(this, data.detailid)}
                                                >退款申请</Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                    }

                </div>
                <div id="refid1" >
                    {
                        !!unionList === false || unionList.length === 0 ?
                            <div className="errordiv"><img alt='' src={require('../../../res/images/zwsj.png')} />
                                <p>暂时没有您要的数据</p>
                            </div>
                            :
                            unionList.map((data, index) => (
                                <div key={index}>
                                    <WhiteSpace size="lg" />
                                    <div className="integralbox" >
                                        <div className="integral-title">
                                            体检验证码：{data.credentialno}
                                        </div>
                                        <div className="integral-cen" >
                                            <div className="cen-box">
                                                <div className="cen-c" ><span>套餐名称：<Link to={`/package/item/${data.opid}/${!!data.title ? data.title : '测试套餐'}/${data.price}`}>{data.title}</Link></span></div>
                                                <div className="cen-c">套餐金额：<span className="mprice">{data.price}<span>积分</span></span></div>
                                                <div className="cen-c"><span>体检人：{data.fullname}</span></div>
                                                <div className="cen-c"><span>体检中心：{data.mcname}</span></div>
                                                <div className="cen-c"><span>预约体检时间：{data.examdate}<span></span>{data.timeSlot}</span></div>

                                            </div>
                                            <div className="cen-but">
                                                <Button className="cenbut" onClick={
                                                    () => {
                                                        alert('取消提示', '确定取消' + fun.FormatTimestr(data.examdate, 'YYYY-MM-dd') + '到' + data.mcname + '的体检预约吗?', [
                                                            { text: '不取消', onPress: () => { } },
                                                            { text: '确定取消', onPress: () => this.CancelOrderment(data) },
                                                        ])
                                                    }
                                                } >取消预约</Button>

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            ))
                    }
                </div>
                <div id="refid2" >
                    {
                        !!unionList === false || unionList.length === 0 ?
                            <div className="errordiv"><img alt='' src={require('../../../res/images/zwsj.png')} />
                                <p>暂时没有您要的数据</p>
                            </div>
                            :
                            unionList.map((data, index) => (
                                <div key={index}>
                                    <WhiteSpace size="lg" />
                                    <div className="integralbox" >
                                        <div className="integral-title">
                                            体检验证码：{data.credentialno}
                                        </div>
                                        <div className="integral-cen" >
                                            <div className="cen-box">
                                                <div className="cen-c" ><span>套餐名称：<Link to={`/package/item/${data.opid}/${!!data.title ? data.title : '测试套餐'}/${data.price}`}>{data.title}</Link></span></div>
                                                <div className="cen-c">套餐金额：<span className="mprice">{data.price}<span>积分</span></span></div>
                                                <div className="cen-c">消费金额：<span className="mprice">{data.spendMoney}<span>积分</span></span></div>
                                                {
                                                    !!data.refundMoney ? <div className="cen-c">退款金额：<span className="mprice">{data.refundMoney}<span>积分</span></span></div> : ''
                                                }
                                                <div className="cen-c"><span>体检人：{data.fullname}</span></div>
                                                <div className="cen-c"><span>体检中心：{data.mcname}</span></div>
                                                <div className="cen-c"><span>预约体检时间：{data.examdate}</span></div>
                                                <div className="cen-c"><span>体检时间：{fun.FormatTimestr(data.spendtime, 'YYYY-MM-dd')}</span></div>

                                            </div>

                                        </div>

                                    </div>
                                </div>
                            ))
                    }

                </div>
                <div id="refid3" >
                    {
                        !!unionList === false || unionList.length === 0 ?
                            <div className="errordiv"><img alt='' src={require('../../../res/images/zwsj.png')} />
                                <p>暂时没有您要的数据</p>
                            </div>
                            :
                            unionList.map((data, index) => (
                                <div key={index}>
                                    <WhiteSpace size="lg" />
                                    <div className="integralbox" >
                                        <div className="integral-title">
                                            体检验证码：{data.credentialno}
                                        </div>
                                        <div className="integral-cen" >
                                            <div className="cen-box">
                                                <div className="cen-c" ><span>套餐名称：<Link to={`/package/item/${data.opid}/${!!data.title ? data.title : '测试套餐'}/${data.price}`}>{data.title}</Link></span></div>
                                                <div className="cen-c">套餐金额：<span className="mprice">{data.price}<span>积分</span></span></div>
                                                <div className="cen-c"><span>体检中心：{data.mcname}</span></div>
                                                <div className="cen-c"><span>购买日期：{fun.FormatTimestr(data.createtime, 'YYYY-MM-dd')}</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                    }
                </div>
            </Tabs>
            <WhiteSpace size="lg" />
            <WhiteSpace size="lg" />
            <WhiteSpace size="lg" />
            <div className="footer">
                <div className="footerbox">
                    <Button className="inline-addbut" onClick={this.onAdd}>添加健康积分</Button>
                </div>
            </div>

            <Modal
                className="addintegral"
                visible={this.state.modal1}
                transparent
                closable={true}
                maskClosable={true}
                onClose={this.onClose('modal1')}
                wrapProps={{ onTouchStart: this.onWrapTouchStart }}
            ><AddIntegral onClose={this.onClose('modal1')} onload={this.onload} />
            </Modal>

            <Modal
                className="refundMoadl"

                visible={this.state.modal3}
                transparent
                closable={true}
                maskClosable={true}
                onClose={this.onClose('modal3')}
                title="订单退款申请"
                // // wrapProps={{ onTouchStart: this.onWrapTouchStart }}
                afterClose={() => { }}
            >
                <Refund detailid={this.state.detailid} onClose={this.onClose('modal3')} GetOrderListpage={this.GetOrderListpage} />
            </Modal>
        </div>;
    }

}